import initSwiper from '../../../components/swiper';

const LOCAL_STORAGE_WISHLIST_KEY = 'shopify-wishlist';
const LOCAL_STORAGE_DELIMITER = ',';
const BUTTON_ACTIVE_CLASS = 'active';
const GRID_LOADED_CLASS = 'loaded';
const CUSTOMER_LOGGED_IN = window.customer?.isLoggedIn;
const CUSTOMER_ID = window.customer?.id;
const ALL_WISHLIST_URL = CUSTOMER_ID ? `http://netlify.blacklemon.dk/.netlify/functions/getCustomerWishlistProducts?store=intersport-dk&customerId=${CUSTOMER_ID}` : '';
const UPDATE_WISHLIST_URL = CUSTOMER_ID ? `http://netlify.blacklemon.dk/.netlify/functions/updateCustomerWishlist?store=intersport-dk&customerId=${CUSTOMER_ID}` : '';
const selectors = {
  button: '[button-wishlist]',
  buttonNotInitialized: '[button-wishlist]:not([data-initialized])',
  grid: '[grid-wishlist]',
  wishlistEmpty: '.wishlist__empty',
  wishlistContent: '.wishlist__grid',
  wishlistText: '.wishlist__text',
  productCard: '.product-card',
  productCardImageWrapper: '.product-card-image-wrapper',
};

document.addEventListener('DOMContentLoaded', () => {
  initButtons();
  initGrid();
  removeDuplicates();
  if (CUSTOMER_LOGGED_IN) {
    updateMergedWishlist();
  }
});

document.addEventListener('shopify-wishlist:updated', async (event) => {
  initGrid();
});

// document.addEventListener('shopify-wishlist:init-product-grid', (event) => {});
// document.addEventListener('shopify-wishlist:init-buttons', (event) => {});

const getProductIdfromHandle = async (handle) => {
  try {
    const res = await fetch(`/products/${handle}.json`);
    const data = await res.json();
    const productId = data.product.id;
    return `gid://shopify/Product/${productId}`;
  } catch (error) {
    return console.error('[Wishlist] Failed to fetch product id', error);
  }
};

const updateMergedWishlist = async () => {
  // merge localstorage and customer metafield
  // add missing products to customer metafield and localstorage

  const localStorageWishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY) || false;
  let localWishlist = [];
  if (localStorageWishlist) {
    if (localStorageWishlist.includes(LOCAL_STORAGE_DELIMITER)) {
      localWishlist = localStorageWishlist.split(LOCAL_STORAGE_DELIMITER);
    } else {
      localWishlist = localStorageWishlist.split();
    }
  }
  const livewishlist = (await fetchWishlist()) || [];
  const mergedWishlist = [...new Set([...localWishlist, ...livewishlist])];

  if (mergedWishlist) {
    mergedWishlist.forEach(async (handle) => {
      const liveWishlistActive = livewishlist.includes(handle);
      if (!liveWishlistActive) {
        const gid = await getProductIdfromHandle(handle);
        await updateWishlistFromFetch(gid);
      }

      const localWishlistActive = localWishlist.includes(handle);
      if (!localWishlistActive) {
        updateWishlistOnLocal(localWishlist, handle);
        let wishlist = await getWishlist();
        reInitButtons(handle, wishlist);
      }
    });
  }
};

const fetchProductCardHTML = async (handle) => {
  const productTileTemplateUrl = `/products/${handle}?view=card`;
  let pageURL = window.location.href;

  try {
    const res = await fetch(productTileTemplateUrl);
    const res_2 = await res.text();
    const text = res_2;
    const parser = new DOMParser();
    const htmlDocument = parser.parseFromString(text, 'text/html');
    if (pageURL.includes('account')) {
      const productImageLink = htmlDocument.documentElement.querySelector(selectors.productCardImageWrapper);
      return productImageLink.outerHTML;
    } else {
      const productCard = htmlDocument.documentElement.querySelector(selectors.productCard);
      return productCard.outerHTML;
    }
  } catch (err) {
    return console.error(`[Wishlist] Failed to load content for handle: ${handle}`, err);
  }
};

const setupGrid = async (grid) => {
  const wishlist = await getWishlist();
  const requests = wishlist.map(fetchProductCardHTML);
  const responses = await Promise.all(requests);
  const wishlistProductCards = responses.join('');
  const wishlistGrid = document.querySelector(selectors.wishlistContent);
  const wishlistEmpty = document.querySelector(selectors.wishlistEmpty);
  const wishlistText = document.querySelector(selectors.wishlistText);
  if (wishlistProductCards) {
    wishlistEmpty.classList.add('hidden');
    if (wishlistText) wishlistText.classList.remove('hidden');
    wishlistGrid.innerHTML = wishlistProductCards;
  } else {
    wishlistEmpty.classList.remove('hidden');
    if (wishlistText) wishlistText.classList.add('hidden');
    wishlistGrid.innerHTML = '';
  }
  grid.classList.add(GRID_LOADED_CLASS);
  initButtons();

  const event = new CustomEvent('shopify-wishlist:init-product-grid', {
    detail: { wishlist: wishlist },
  });
  document.dispatchEvent(event);
  return;
};

const setupButtons = async (buttons, reInit = false, wishlist = []) => {
  buttons.forEach(async (button) => {
    button.setAttribute('data-initialized', '');
    const productHandle = button.dataset.productHandle || false;
    if (!productHandle) {
      return console.error('[Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist.');
    }

    const wishlistActive = wishlist.includes(productHandle);
    button.classList.toggle(BUTTON_ACTIVE_CLASS, wishlistActive);

    if (!reInit) {
      button.addEventListener('click', async () => {
        await updateWishlist(productHandle);
      });
    }
  });
};

const initGrid = async () => {
  const grid = document.querySelector(selectors.grid) || false;
  if (grid) {
    await setupGrid(grid);
    setTimeout(() => {
      initSwiper();
    }, 1000);
  }
};

const initButtons = async () => {
  const wishlist = await getWishlist();
  const buttons = document.querySelectorAll(selectors.buttonNotInitialized) || [];
  if (buttons.length) {
    setupButtons(buttons, false, wishlist);
  } else {
    return;
  }
  const event = new CustomEvent('shopify-wishlist:init-buttons', {
    detail: { wishlist: wishlist },
  });
  document.dispatchEvent(event);
};

const reInitButtons = async (handle, updatedWishlist) => {
  let buttons = document.querySelectorAll(`[data-product-handle="${handle}"]`) || [];
  if (buttons.length) {
    setupButtons(buttons, true, updatedWishlist);
  } else {
    return;
  }
};

const fetchWishlist = async () => {
  try {
    const res = await fetch(ALL_WISHLIST_URL);
    const data = await res.json();
    const products = data.metafield.value;
    return products;
  } catch (error) {
    return console.error('[Wishlist] Failed to fetch wishlist', error);
  }
};

const getWishlist = async () => {
  const wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY) || false;
  if (wishlist) {
    return wishlist.split(LOCAL_STORAGE_DELIMITER);
  } else {
    return [];
  }
};

const removeDuplicates = async () => {
  const wishlist = await getWishlist();
  const uniqueWishlist = [...new Set(wishlist)];
  updateWishlistOnLocal(uniqueWishlist);
};

const updateWishlistFromFetch = async (gid) => {
  try {
    const res = await fetch(UPDATE_WISHLIST_URL, {
      method: 'POST',
      body: gid,
    });
    const data = await res.json();
    const products = data.metafield.value;
    return products;
  } catch (error) {
    return console.error('[Wishlist] Failed to update wishlist', error);
  }
};

const updateWishlistOnLocal = (wishlist = [], handle) => {
  if (handle) {
    const indexInWishlist = wishlist.indexOf(handle);
    if (indexInWishlist === -1) {
      wishlist.push(handle);
    } else {
      wishlist.splice(indexInWishlist, 1);
    }
  }

  const wishlistString = wishlist.join(LOCAL_STORAGE_DELIMITER);

  if (wishlist.length) {
    localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, wishlistString);
  } else {
    localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);
  }
};

const updateWishlist = async (handle, disableEvent = false) => {
  let wishlist = await getWishlist();
  updateWishlistOnLocal(wishlist, handle);
  reInitButtons(handle, wishlist);

  if (CUSTOMER_LOGGED_IN) {
    const gid = await getProductIdfromHandle(handle);
    await updateWishlistFromFetch(gid);
    wishlist = await getWishlist();
  }
  if (!disableEvent) {
    const event = new CustomEvent('shopify-wishlist:updated', {
      detail: { wishlist: wishlist },
    });
    document.dispatchEvent(event);
  }
};

export default initButtons;
